module.exports = __webpack_public_path__ + "static/media/banner.931c1bfa.png";